var map = {
	"./A star.png": 439,
	"./avatar.png": 783,
	"./django.png": 841,
	"./djangohtmx.png": 222,
	"./ecommerce.jpg": 814,
	"./git.png": 186,
	"./html.png": 59,
	"./linux.png": 972,
	"./python.png": 78,
	"./react.png": 911,
	"./teenpatti.png": 900
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 206;